import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFilter } from './filterProvider';
import { ChevronDownIcon, ChevronRightIcon } from '@umanforge/common';

interface FilterButtonProps {
  titles?: [string, string];   // [expanded, collapsed]
  tooltips?: [string, string]; // [show, hide]
  icon?: React.ElementType;
  className?: string;
}

const FilterButton: React.FC<FilterButtonProps> = ( { titles, tooltips, icon: Icon, className } ) => {
  const { t } = useTranslation();
  const { isCollapsed, toggle } = useFilter();

  const [ titleExpanded, titleCollapsed ] = titles ?? [];
  const resolvedTitleExpanded = titleExpanded ?? t( 'common:filter.refine' );
  const resolvedTitleCollapsed = titleCollapsed ?? t( 'common:filter.refine' );

  const [ tooltipShow, tooltipHide ] = tooltips ?? [];
  const resolvedTooltipShow = tooltipShow ?? t( 'common:filter.show' );
  const resolvedTooltipHide = tooltipHide ?? t( 'common:filter.hide' );

  return (
    <div className={`flex flex-col gap-4 ${className ?? ''}`}>
      <div className="flex items-center">
        <button
          onClick={toggle}
          className="flex items-center justify-between w-full px-4 py-3 rounded-md shadow bg-orange-100 hover:bg-orange-200 border-2 border-orange-200"
          title={isCollapsed ? resolvedTooltipShow : resolvedTooltipHide}
        >
          {/* Texte */}
          <span className="text-orange-700 font-semibold text-lg flex flex-row gap-4">
            {Icon && <Icon />}
            {t( isCollapsed ? resolvedTitleCollapsed : resolvedTitleExpanded )}
          </span>

          {/* Icône */}
          <span className="ml-4">
            {isCollapsed ? (
              <ChevronRightIcon className='h-5 w-5' />
            ) : (
              <ChevronDownIcon className='h-5 w-5' />
            )}
          </span>
        </button>
      </div>
    </div>
  );
};

export { FilterButton };
